import { AxiosRequestConfig, AxiosResponse } from "axios";
import axios, { configHeader } from "./axios";

export interface ErrorLog {
  id: number;
  level: string;
  method: string | null;
  path: string | null;
  status: number | null;
  message: string | null;
  stack: string | null;
  userAgent: string | null;
  ip: string | null;
  context: Record<string, unknown> | null;
  createdAt: string;
}

export interface AuditLog {
  id: number;
  actorId: number;
  action: string;
  targetType: string | null;
  targetId: number | null;
  /** Resolved by the server (best-effort): user name, menu name, broadcast text snippet, etc. */
  targetName: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  actor?: {
    id: number;
    email: string;
    name: string;
    role: string;
  } | null;
}

interface PageResp<T> {
  rows: T[];
  total: number;
}

export const getErrorLogs = async (
  limit = 100,
  offset = 0,
  q?: string
): Promise<PageResp<ErrorLog>> => {
  const response: AxiosResponse<PageResp<ErrorLog>> = await axios.get(
    "/admin/errors",
    { ...configHeader(), params: { limit, offset, q: q || undefined } } as AxiosRequestConfig
  );
  return response.data;
};

export const getAuditLogs = async (
  limit = 100,
  offset = 0,
  q?: string
): Promise<PageResp<AuditLog>> => {
  const response: AxiosResponse<PageResp<AuditLog>> = await axios.get(
    "/admin/audit",
    { ...configHeader(), params: { limit, offset, q: q || undefined } } as AxiosRequestConfig
  );
  return response.data;
};
